/**
 * 复制文本到剪贴板
 * 优先使用现代 Clipboard API,不可用时回退到 execCommand
 * @param {string} text 要复制的文本
 * @returns {Promise<boolean>} true=成功
 */
export async function copyText(text) {
  const value = String(text || '');
  if (!value) return false;

  // 现代 API(要求 HTTPS 或 localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch (e) {
      // 权限拒绝或其它错误,回退
    }
  }

  // 兜底:临时 textarea + execCommand('copy')
  const textarea = document.createElement('textarea');
  textarea.value = value;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  textarea.style.top = '0';
  document.body.appendChild(textarea);
  const selected = document.getSelection().rangeCount > 0
    ? document.getSelection().getRangeAt(0)
    : null;
  textarea.select();
  textarea.setSelectionRange(0, value.length);
  let ok = false;
  try {
    ok = document.execCommand('copy');
  } catch (e) {
    ok = false;
  }
  document.body.removeChild(textarea);
  // 恢复原来的选区
  if (selected) {
    document.getSelection().removeAllRanges();
    document.getSelection().addRange(selected);
  }
  return ok;
}
